import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import stockBoitierService from '../../services/stockBoitierService';
import { StockBoitier, StatutStock } from '../../types';

interface StockBoitierState {
  list: StockBoitier[];
  loading: boolean;
  error: string | null;
}

const initialState: StockBoitierState = { list: [], loading: false, error: null };

export const fetchBoitiers = createAsyncThunk('stockBoitier/fetchAll', () =>
  stockBoitierService.getAll()
);

export const createBoitier = createAsyncThunk(
  'stockBoitier/create',
  (data: { imei: string; modele: string }) => stockBoitierService.create(data)
);

export const updateBoitierStatut = createAsyncThunk(
  'stockBoitier/update',
  ({ id, statut, modele, imei }: { id: number; statut: StatutStock; modele?: string; imei?: string }) =>
    stockBoitierService.update(id, { statut, modele, imei })
);

export const deleteBoitier = createAsyncThunk('stockBoitier/delete', async (id: number) => {
  await stockBoitierService.delete(id);
  return id;
});

const stockBoitierSlice = createSlice({
  name: 'stockBoitier',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchBoitiers.pending, (state) => { state.loading = true; state.error = null; })
      .addCase(fetchBoitiers.fulfilled, (state, action) => { state.loading = false; state.list = action.payload; })
      .addCase(fetchBoitiers.rejected, (state, action) => { state.loading = false; state.error = action.error.message ?? 'Erreur'; })
      .addCase(createBoitier.fulfilled, (state, action) => { state.list.unshift(action.payload); })
      .addCase(updateBoitierStatut.fulfilled, (state, action) => {
        const idx = state.list.findIndex((i) => i.id === action.payload.id);
        if (idx !== -1) state.list[idx] = action.payload;
      })
      .addCase(deleteBoitier.fulfilled, (state, action) => {
        state.list = state.list.filter((i) => i.id !== action.payload);
      });
  },
});

export default stockBoitierSlice.reducer;
